<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding: 20px">
        <!-- <div
          style="padding:10px;font-size:20px;color:#1bb24b;font-weight:bold;display:inline-block;cursor:pointer"
        >首页板块</div>-->
      </div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div style>
            <div style="display: inline-block; width: 70%">
              <el-button
                @click="onDialogboolAddNewOpen()"
                style="color: #1bb24b; border-color: #1bb24b"
                >添加新禁送日</el-button
              >
            </div>
            <div style="display: inline-block; text-align: right; width: 30%">
              <div
                style="
                  display: inline-block;
                  text-align: right;
                  max-width: 40%;
                  margin-right: 10px;
                "
              ></div>
            </div>
          </div>
          <div style="margin-top: 3%">
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column prop="recordDate" label="日期"></el-table-column>
              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <!-- ****************************  operation **************************** -->
      <el-dialog
        title="日期操作"
        :visible.sync="boolAddNew"
        width="70%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            禁送日期
          </div>

          <el-date-picker
            v-model="form.recordDate"
            value-format="yyyy-MM-dd"
            style="display: inline-block; width: 70%"
            type="date"
          ></el-date-picker>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onAddNewConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >

          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="删除确认"
        :visible.sync="boolDelete"
        width="70%"
        style="text-align: left"
        :before-close="onDialogBoolDeleteClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDeleteConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolDeleteClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <!-- ************************************************************************************* -->
    </div>
  </div>
</template>

<script>
export default {
  name: "banDate",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,
      tableDataList: [],
      tableDataTotal: 0,

      currentSubData: {},

      boolDelete: false,
      boolAddNew: false,

      form: {
        recordDate: "",
      },
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchBanDate();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },

    // fetch categories
    onFetchBanDate() {
      this.fullscreenLoading = true;
      this.axios.post(this.$urlGlobal + "adminFetchBanDate", {}).then((res) => {
        this.tableDataList = res.data.data;
        this.fullscreenLoading = false;
      });
    },

    // add new cate operation
    onDialogboolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      this.form = {
        recordDate: "",
      };
    },
    onAddNewConfirm() {
      if (this.form.name == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.boolAddNew = false;

      this.axios
        .post(this.$urlGlobal + "adminAddNewBanDate", {
          recordDate: this.form.recordDate,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchBanDate();
        });
    },

    // delete categories operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
      this.form = {
        name: this.currentData.name,
      };
    },

    onDeleteConfirm() {
      if (this.form.name == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }

      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteBanDate", {
          id: this.currentData.id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolDeleteClose();
          this.onFetchBanDate();
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "delete":
          this.onDialogBoolDeleteOpen();
          break;
      }
    },

    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

